import { FieldHtmlNameUtil } from '@onshape/www-inertia';
import UnifiedSignupScreenComponent from '../UnifiedSignupScreenComponent';
import type { UnifiedSignupScreenName } from '../UnifiedSignupScreenName';
import AbstractSubmitSignupScreen from './AbstractSubmitSignupScreen';
import UnifiedSignupPlan from '../session-info/UnifiedSignupPlan';

export default class ProDetails2SignupScreen extends AbstractSubmitSignupScreen {
  public readonly screenName: UnifiedSignupScreenName = 'uss-details-pro-2of2';

  public getThisScreensVisibleComponents(): UnifiedSignupScreenComponent[] {
    const addresses = [
      this.getField(FieldHtmlNameUtil.addEmail1),
      this.getField(FieldHtmlNameUtil.addEmail2),
      this.getField(FieldHtmlNameUtil.addEmail3),
      this.getField(FieldHtmlNameUtil.addEmail4),
      this.getField(FieldHtmlNameUtil.addEmail5),
    ];
    addresses.forEach((field) => {
      field.autocomplete = 'off';
    });

    return [
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.currentCadSystem).shuffleOptionList(),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.howManyCadUsersAtCompany),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.howManyUserToTrial),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.addEmail1),
        isRequired: false,
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.addEmail2),
        isRequired: false,
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.addEmail3),
        isRequired: false,
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.addEmail4),
        isRequired: false,
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.addEmail5),
        isRequired: false,
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.itarReg),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.howDidYouHearAboutUs),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.tosConsentAccepted),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.privacyConsentAccepted),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.recaptcha),
      }),
      new UnifiedSignupScreenComponent({
        displayField: this.getField(FieldHtmlNameUtil.geoCountry),
      }),
    ];
  }

  public predicate(): boolean {
    const { chosenPlan, completedDetailsScreens, formSubmitStatus } = this.sessionInfo.value;
    if (formSubmitStatus !== null && formSubmitStatus !== 'submit-failed') {
      return false;
    }
    if (chosenPlan === null || !chosenPlan.compareTo(UnifiedSignupPlan.pro)) {
      return false;
    }
    if (completedDetailsScreens.length !== 1) {
      return false;
    }

    return true;
  }

  public override getProgress(): number {
    return 85;
  }
}
